import React from "react";
import { combineReducers } from "redux";
import { homeReducer } from "./homeReducer";
import { appReducer } from "./appReducer";

export const rootReducer = combineReducers({ homeReducer, appReducer });
